import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../services/api";

export const fetchAdminFiles = createAsyncThunk(
  "files/fetchAdminFiles",
  async (params = {}, { rejectWithValue }) => {
    try {
      const response = await api.get("/files", {
        params: { scope: "all", ...params },
      });
      return response.data.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Failed to fetch files"
      );
    }
  }
);

export const uploadAdminFile = createAsyncThunk(
  "files/uploadAdminFile",
  async ({ file, category = "content_media" }, { rejectWithValue }) => {
    try {
      const formData = new FormData();
      formData.append("file", file);
      formData.append("category", category);
      const response = await api.post("/files/upload", formData);
      return response.data.data?.file;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Failed to upload file"
      );
    }
  }
);

export const deleteAdminFile = createAsyncThunk(
  "files/deleteAdminFile",
  async (fileId, { rejectWithValue }) => {
    try {
      await api.delete(`/files/${fileId}`);
      return fileId;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Failed to delete file"
      );
    }
  }
);

const fileSlice = createSlice({
  name: "files",
  initialState: {
    files: [],
    total: 0,
    loading: false,
    error: null,
  },
  reducers: {
    clearFileError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAdminFiles.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAdminFiles.fulfilled, (state, action) => {
        state.loading = false;
        state.files = action.payload.files || [];
        state.total = action.payload.total ?? state.files.length;
      })
      .addCase(fetchAdminFiles.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(uploadAdminFile.fulfilled, (state, action) => {
        if (action.payload) {
          state.files = [action.payload, ...state.files];
          state.total += 1;
        }
      })
      .addCase(deleteAdminFile.fulfilled, (state, action) => {
        state.files = state.files.filter((f) => f.id !== action.payload);
        state.total = Math.max(0, state.total - 1);
      });
  },
});

export const { clearFileError } = fileSlice.actions;
export default fileSlice.reducer;
